import { NgClass } from '@angular/common';
import { booleanAttribute, Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

// Custom transform function to handle multiple truthy representations
// [MVV] Specifically for the fieldNgModel input for the checkbox when value is prefilled
function customBooleanTransform(value: unknown): boolean {
  if (value === true || value === 'true' || value === '1' || value === 1) {
    return true;
  }
  return false;
}

@Component({
  selector: 'app-cw-checkbox',
  templateUrl: './cw-checkbox.component.html',
  styleUrls: ['./cw-checkbox.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  imports: [FormsModule, NgClass, TranslateModule]
})
export class CwCheckboxComponent {

  @Input() id: string;
  @Input() name: string;
  @Input({ transform: booleanAttribute }) isDisabled = false;
  @Input({ transform: customBooleanTransform }) fieldNgModel = false;
  @Input({ transform: booleanAttribute }) isRequired = false;
  @Input() customLabelClass = 'ps-2';

  @Output() selectionChange = new EventEmitter<{ event: any, id: any }>();

  onChange(event: any, id: any): void {
    this.selectionChange.emit({ event: event, id: id });
  }
}
